import { render, staticRenderFns } from "./ProductBuyRecordTable.vue?vue&type=template&id=e1f74d6c&"
import script from "./ProductBuyRecordTable.vue?vue&type=script&lang=js&"
export * from "./ProductBuyRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports